import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import * as Entities from '@shared/entities';
import { lastValueFrom } from 'rxjs';
import { LoggerService } from '../services/logger.service';
import { Result, ListResponse } from '@shared/models';
import { ConfigService } from '../services/config.service';

@Injectable({
  providedIn: 'root',
})
export class DispositionMapsApi {
  private serviceUri = '';

  constructor(
    private http: HttpClient,
    private log: LoggerService,
    private configService: ConfigService
  ) {
    this.configService.Config.subscribe((config) => {
      if (config?.apiUri) {
        this.serviceUri = `${config.apiUri}/disposition-maps/`;
      }
    });
  }

  async loadDispositionMaps(_force: boolean = false): Promise<ListResponse<Entities.DispositionMap>> {
    const result = await lastValueFrom(this.http.get<Result<ListResponse<Entities.DispositionMap>>>(this.serviceUri));
    if (result.successful) {
      return result.data;
    }

    this.log.displayError(result.message || 'Unable to load disposition maps', 'dispositionMaps.service->load');
    return { records: [] } as ListResponse<Entities.DispositionMap>;
  }

  async create(map: Entities.DispositionMap): Promise<Result<number>> {
    const result = await lastValueFrom(this.http.post<Result<number>>(this.serviceUri, map));
    if (result.successful) {
      this.log.displaySuccess('Disposition Map created', 'dispositionMaps.service->create');
    } else {
      this.log.displayError(result.message, 'dispositionMaps.service->create');
    }
    return result;
  }

  async update(id: number, map: Entities.DispositionMap): Promise<Result<number>> {
    const result = await lastValueFrom(this.http.put<Result<number>>(this.serviceUri + id, map));
    if (result.successful) {
      this.log.displaySuccess('Disposition Map updated', 'dispositionMaps.service->update');
    } else {
      this.log.displayError('Disposition Map update failed:' + result.message, 'dispositionMaps.service->update');
    }
    console.debug('update', result);
    return result;
  }

  async delete(id: number): Promise<Result<number>> {
    const result = await lastValueFrom(this.http.delete<Result<number>>(this.serviceUri + id));
    if (result.successful) {
      this.log.displaySuccess('Disposition Map deleted', 'dispositionMaps.service->delete');
    } else {
      this.log.displayError('Disposition Map delete failed:' + result.message, 'dispositionMaps.service->delete');
    }
    console.debug('delete', result);
    return result;
  }
}
